module.exports = function (r) {
  var e = {};

  function t(n) {
    if (e[n]) return e[n].exports;
    var a = e[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return r[n].call(a.exports, a, a.exports, t), a.l = !0, a.exports;
  }

  return t.m = r, t.c = e, t.d = function (r, e, n) {
    t.o(r, e) || Object.defineProperty(r, e, {
      enumerable: !0,
      get: n
    });
  }, t.r = function (r) {
    "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(r, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(r, "__esModule", {
      value: !0
    });
  }, t.t = function (r, e) {
    if (1 & e && (r = t(r)), 8 & e) return r;
    if (4 & e && "object" === typeof r && r && r.__esModule) return r;
    var n = Object.create(null);
    if (t.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: r
    }), 2 & e && "string" != typeof r) for (var a in r) {
      t.d(n, a, function (e) {
        return r[e];
      }.bind(null, a));
    }
    return n;
  }, t.n = function (r) {
    var e = r && r.__esModule ? function () {
      return r.default;
    } : function () {
      return r;
    };
    return t.d(e, "a", e), e;
  }, t.o = function (r, e) {
    return Object.prototype.hasOwnProperty.call(r, e);
  }, t.p = "/ymzuiku/mix-color.git/", t(t.s = 0);
}([function (r, e, t) {
  "use strict";

  function n(r) {
    var e = {
      r: 0,
      g: 0,
      b: 0,
      a: 1
    };
    if (0 === r.search(/#/)) 3 === (r = r.replace(/#/, "")).length ? (e.r = parseInt(r[0] + r[0], 16), e.g = parseInt(r[1] + r[1], 16), e.b = parseInt(r[2] + r[2], 16)) : 6 === r.length ? (e.r = parseInt(r[0] + r[1], 16), e.g = parseInt(r[2] + r[3], 16), e.b = parseInt(r[4] + r[5], 16)) : (e.r = parseInt(r[0] + r[1], 16), e.g = parseInt(r[2] + r[3], 16), e.b = parseInt(r[4] + r[5], 16), e.a = parseInt(r[6] + r[7], 16) / 255);else if (0 === r.search(/rgba\(/)) {
      var t = (r = r.replace(/rgba\(|\)|\s+/g, "")).split(",");
      e.r = Number(t[0]), e.g = Number(t[1]), e.b = Number(t[2]), e.a = Number(t[3]);
    } else if (0 === r.search(/rgb\(/)) {
      var n = (r = r.replace(/rgb\(|\)|\s+/g, "")).split(",");
      e.r = Number(n[0]), e.g = Number(n[1]), e.b = Number(n[2]);
    }
    return e;
  }

  function a(r, e, t) {
    var n = r !== e ? r + (e - r) * t : r;
    return n = n > 255 ? 255 : n, Math.floor(n);
  }

  t.r(e), e.default = function (r, e) {
    var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;

    if ("number" === typeof e) {
      var o = n(r);
      return "rgba(".concat(o.r, ", ").concat(o.g, ", ").concat(o.b, ", ").concat(e, ")");
    }

    var u = n(r),
        c = n(e),
        i = a(u.r, c.r, t),
        l = a(u.g, c.g, t),
        f = a(u.b, c.b, t),
        b = function (r, e, t) {
      var n;
      return t = 1 - t < 0 ? 0 : 1 - t, 1e4 * (n = (n = (n = r * e === 1 ? 1 : 0 === r ? e * t : 0 === e ? r * t : 0 === t ? r * e : r * e * t) > 1 ? 1 : n) < 0 ? 0 : n).toFixed(4) / 1e4;
    }(u.a, c.a, t);

    return "rgba(".concat(i, ", ").concat(l, ", ").concat(f, ", ").concat(b, ")");
  };
}]);